(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amaca-homepage"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('amaca-collection-slideshow')) {
  customElements.define('amaca-collection-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.children);
      this.index = 0;
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.card = this.closest('.amaca-collection-card');
      this.visible = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.sync = () => {
        clearInterval(this.timer);
        if (this.slides.length < 2 || !this.desktop.matches || this.reduced.matches || !this.visible || document.hidden || this.card.matches(':hover, :focus-within')) return;
        this.timer = setInterval(() => {
          const next = (this.index + 1) % this.slides.length;
          const image = this.slides[next].querySelector('img');
          if (!image.complete || !image.naturalWidth) return;
          this.slides[this.index].classList.remove('is-active');
          this.slides[next].classList.add('is-active');
          this.index = next;
        }, Number(this.dataset.interval) || 5000);
      };
      this.desktop.addEventListener('change', this.sync, options);
      this.reduced.addEventListener('change', this.sync, options);
      document.addEventListener('visibilitychange', this.sync, options);
      ['mouseenter', 'mouseleave', 'focusin'].forEach(event => this.card.addEventListener(event, this.sync, options));
      this.card.addEventListener('focusout', () => requestAnimationFrame(() => this.isConnected && this.sync()), options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this.card);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}

if (!customElements.get('amaca-hero-slideshow')) {
  customElements.define('amaca-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('.hero-sequence-image'));
      this.index = 0;
      this.device = matchMedia(this.dataset.device === 'desktop' ? '(min-width: 750px)' : '(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.sync = () => {
        clearInterval(this.timer);
        if (this.images.length < 2 || !this.device.matches || this.reduced.matches || document.hidden || !this.visible) return;
        this.timer = setInterval(() => {
          const next = (this.index + 1) % this.images.length;
          if (!this.images[next].complete || !this.images[next].naturalWidth) return;
          this.images[next].classList.remove('hero-sequence-image--hidden');
          this.images[this.index].classList.add('hero-sequence-image--hidden');
          this.index = next;
        }, 5000);
      };
      this.device.addEventListener('change', this.sync, options);
      this.reduced.addEventListener('change', this.sync, options);
      document.addEventListener('visibilitychange', this.sync, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
      this.observer.observe(this.parentElement);
    }
    disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.scrollToggleThreshold = 28;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = scrollTop - this.currentScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (Math.abs(scrollDelta) < this.scrollToggleThreshold && scrollTop > this.headerBounds.bottom) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
